import createReducer from '../../utils/createReducer';
import * as constants from './constants';

const initialState = {
  isFetching: false,
  errorMessage: null,
  data: [],
};

export default createReducer(initialState, {
  [constants.STAT_CAMPAIGN_DETAIL_REQUEST](state, action) {
    const { isFetching } = action;
    return Object.assign({}, state, {
      isFetching,
    });
  },

  [constants.STAT_CAMPAIGN_DETAIL_FAILURE](state, action) {
    const { isFetching, errorMessage } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
    });
  },

  [constants.STAT_CAMPAIGN_DETAIL_SUCCESS](state, action) {
    const { isFetching, errorMessage, data } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
      data,
    });
  },
});



// WEBPACK FOOTER //
// ./src/containers/Statistics/reducer.js